import { RegisterTermsDialogComponent } from './register-terms-dialog/register-terms-dialog.component';
import { OkCancelDialogComponent } from './ok-cancel-dialog/ok-cancel-dialog.component';

export const MODALS = [OkCancelDialogComponent, RegisterTermsDialogComponent];

export * from './base-modal/base-modal';
export * from './register-terms-dialog/register-terms-dialog.component';
export * from './ok-cancel-dialog/ok-cancel-dialog.component';
